class PackAndMoveBooking {

    constructor() {

        this.currentStep = 1;

        this.booking = {
            moveFrom: '',
            moveTo: '',
            route: '',
            package: {
                variantId: '',
                title: '',
                price: 0
            }
        };

        this.steps = [
            ...document.querySelectorAll('[data-booking-step]')
        ];

        this.progress = [
            ...document.querySelectorAll('[data-progress-step]')
        ];

        if (!this.steps.length) return;

        this.bindEvents();

        this.bindPackageSelection();

        this.showStep(this.currentStep);

    }

    bindEvents() {

        document.addEventListener('click', (event) => {

            const nextButton = event.target.closest('[data-booking-next]');
            const backButton = event.target.closest('[data-booking-back]');

            if (nextButton) {

                event.preventDefault();

                this.next();

            }

            if (backButton) {

                event.preventDefault();

                this.previous();

            }

        });

    }

    next() {

        if (this.currentStep === 1) {

            const moveFrom = document.getElementById('moving-from').value;
            const moveTo = document.getElementById('moving-to').value;

            if (!moveFrom || !moveTo) {
                alert('Please select both properties.');
                return;
            }

            this.booking.moveFrom = moveFrom;
            this.booking.moveTo = moveTo;
            this.booking.route = `${moveFrom} to ${moveTo}`;

            this.filterPackages();

            document.dispatchEvent(new CustomEvent('packages:filtered'));

            console.log(this.booking);

        }

        if (this.currentStep >= this.steps.length) {
            return;
        }

        this.showStep(this.currentStep + 1);

        }

        previous() {

            if (this.currentStep <= 1) {
                return;
            }

            this.showStep(this.currentStep - 1);

        }

        filterPackages() {

                        const cards = document.querySelectorAll('.pack-and-move-package-card');

                        cards.forEach((card) => {

                            const route = card.dataset.route;

                            const [fromPart, toPart] = route.split(' to ');

                            const fromOptions = fromPart
                                .split('/')
                                .map(item => item.trim());

                            const matches =
                                fromOptions.includes(this.booking.moveFrom) &&
                                toPart.trim() === this.booking.moveTo;

                            card.hidden = !matches;
                            card.classList.toggle('is-hidden', !matches);

                        });

                    }

            bindPackageSelection() {

                const cards = document.querySelectorAll('.pack-and-move-package-card');

                cards.forEach((card) => {

                    const radio = card.querySelector(
                        '.pack-and-move-package-card__radio'
                    );

                    card.addEventListener('click', () => {

                        radio.checked = true;

                        cards.forEach((item) => {

                            item.classList.remove('is-selected');

                        });

                        card.classList.add('is-selected');

                        this.booking.package = {

                            variantId: card.dataset.variantId,

                            title: card.dataset.packageTitle,

                            route: card.dataset.route,

                            price: Number(card.dataset.packagePrice)

                        };

                        console.log('Package Selected');

                        console.log(this.booking.package);

                    });

                });


            }

        goTo(step) {

            if (step < 1 || step > this.steps.length) {
                return;
            }

            this.showStep(step);

        }

        showStep(step) {

            this.currentStep = step;

            this.steps.forEach((panel) => {

                const panelStep = Number(panel.dataset.bookingStep);

                const active = panelStep === step;

                panel.hidden = !active;

                panel.classList.toggle('is-active', active);

            });

            this.updateProgress();

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

        }

        updateProgress() {

            this.progress.forEach((item) => {

                const progressStep = Number(item.dataset.progressStep);

                item.classList.remove(
                    'is-active',
                    'is-completed'
                );

                if (progressStep < this.currentStep) {

                    item.classList.add('is-completed');

                }

                if (progressStep === this.currentStep) {

                    item.classList.add('is-active');

                }

            });

        }

    }

document.addEventListener('DOMContentLoaded', () => {

    window.packAndMoveBooking = new PackAndMoveBooking();

});